import { axiosInstanceV2 } from "@src/shared/api";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { REQUEST_HH_API_URL } from "../constants";
import {
  IStructureVacancyRequestDto,
  IStructureVacancyResponseData,
} from "../interfaces/jobRequestDto";

export const structureVacancy = async (data: IStructureVacancyRequestDto) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;

  const response = await axiosInstanceV2.post<IStructureVacancyResponseData>(
    REQUEST_HH_API_URL.getStructureVacancy(),
    data,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );

  return response;
};


